import React, { useEffect, useState } from 'react'
import ApiRequest from '../Common/restservice';
import { errorToast, successToast } from '../Common/showtoast';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

function Convert() {
    const [companywallet, setcompanywallet] = useState("");
    const [payoutwallet, setpayoutwallet] = useState("");
    const [amount, setAmount] = useState("");
    const [wallettype, setwallettype] = useState("main");
    const navigate = useNavigate();
    useEffect(() => {
        GetDashboardDetails();
    }, [])
    const GetDashboardDetails = async () => {
        let res = await ApiRequest("GetDashboardDetails.asp", "GET", null, {
            Authorization: localStorage.getItem("token"),
        });
        console.log(res);
        if (res.status === "error") {
            errorToast(res.message);
            if (res.message === "Session Expired") {
                localStorage.clear();
                navigate("/login");
            }
            return;
        }
        setcompanywallet(res.availablecompanywallet);
        setpayoutwallet(res.availablePaywallet);
    }

    const convertConfirm = async (json) => {
        let res = await ApiRequest("ConvertWallet.asp",
            "POST",
            json,
            { Authorization: localStorage.getItem("token") }
        );
        console.log(res);
        if (res.status === "error") {
            errorToast(res.message);
            if (res.message === "Session Expired") {
                localStorage.clear();
                navigate("/login");
            }
            return;
        }
        successToast(res.message);
        setAmount("");
        GetDashboardDetails();
    }
    return (
        <section className='content'>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-xm-12">
                    <div className="card overflow-hidden dash1-card border-0 ">
                        <div className="card-body">
                            <h3 className=" mt-3 mb-3 text-center">
                                Income Wallet to Main Wallet
                            </h3>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <label
                                                className=" btn btn-primary-color"
                                                style={{ padding: "unset" }}
                                            >
                                                Income Wallet Balance
                                            </label>
                                        </div>
                                        <div className="col-lg-6">
                                            <h6>Rs. {payoutwallet || 0}</h6>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <label
                                                className="btn btn-primary-color"
                                                style={{ padding: "unset" }}
                                            >
                                                Main Wallet Balance
                                            </label>
                                        </div>
                                        <div className="col-lg-6">
                                            <h6>Rs. {companywallet || 0}</h6>
                                        </div>
                                    </div>

                                    <div className="row mt-2">
                                        <div className="col-lg-6">
                                            <button
                                                className=" btn btn-primary-color"
                                                style={{ padding: "unset" }}
                                                type="button"
                                            >
                                                Amount to transfer
                                            </button>
                                        </div>
                                        <div className="col-lg-6">
                                            <input
                                                type="text"
                                                className="col-lg-6 col-md-12 form-control"
                                                placeholder="Please enter amount"
                                                aria-label="Amount"
                                                tabIndex="1"
                                                value={amount}
                                                onChange={(e) => {
                                                    setAmount(e.target.value);
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mt-2">
                                        <div className="col-lg-12 text-center">
                                            <button
                                                className="btn btn-primary mt-5"
                                                onClick={async (e) => {
                                                    if (!amount) {
                                                        errorToast("Enter valid amount");
                                                        return;
                                                    }
                                                    // let res = await ApiRequest("ConvertWalletConfirm.asp",
                                                    //     "POST",
                                                    //     {
                                                    //         walletamount: amount,
                                                    //         wallettype: wallettype,
                                                    //     },
                                                    //     { Authorization: localStorage.getItem("token") }
                                                    // );
                                                    // console.log(res);
                                                    // if (res.status === "error") {
                                                    //     errorToast(res.message);
                                                    //     if (res.message === "Session Expired") {
                                                    //         localStorage.clear();
                                                    //         navigate("/login");
                                                    //     }
                                                    //     return;
                                                    // }
                                                    // successToast(res.message);
                                                    const { value: tac } = await Swal.fire({
                                                        title: "Please enter the Login password to continue",
                                                        input: "password",
                                                        inputLabel: "Your Login Password",
                                                        inputPlaceholder: "Enter your login password",
                                                        showCancelButton: true,
                                                        inputValidator: (value) => {
                                                            if (!value) {
                                                                return "Please enter your password!";
                                                            }
                                                        },
                                                    });
                                                    if (!tac) {
                                                        return;
                                                    }
                                                    var t = {
                                                        walletamount: amount,
                                                        tac: tac,
                                                        OTP:tac,
                                                        wallettype: wallettype,
                                                    };
                                                    await convertConfirm(t);
                                                }}
                                            >
                                                Convert
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Convert
